module.exports = __webpack_public_path__ + "static/img/ga.29f203bb.svg";